import { render, staticRenderFns } from "./OthersGoal.vue?vue&type=template&id=4ca6bfef&scoped=true"
import script from "./OthersGoal.vue?vue&type=script&lang=js"
export * from "./OthersGoal.vue?vue&type=script&lang=js"
import style0 from "./OthersGoal.vue?vue&type=style&index=0&id=4ca6bfef&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca6bfef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ca6bfef')) {
      api.createRecord('4ca6bfef', component.options)
    } else {
      api.reload('4ca6bfef', component.options)
    }
    module.hot.accept("./OthersGoal.vue?vue&type=template&id=4ca6bfef&scoped=true", function () {
      api.rerender('4ca6bfef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/employee/rating/partials/OthersGoal.vue"
export default component.exports